import { Navigate, useLocation } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import { ApplicationForm } from "../../components/ApplicationForm/ApplicationForm";
import { ApplicationFormContextProvider } from "../../components/ApplicationForm/ApplicationFrom.ctx";
import { isUserOrArchitect } from "../../hoc/isUserOrArchitect";
import { useApplication, useBasicForm } from "../../hooks/applications.hooks";
import { cookieUtils } from "../../utils/cookieUtils";

export const EditApplication = isUserOrArchitect(() => {
  const location = useLocation();

  const id = +location.state?.id;

  const { isFetching: isFetching2, isError: isError1, data } = useBasicForm();
  const {
    isFetching: isFetching1,
    data: application,
    isError: isError2,
  } = useApplication({ id });

  if (!id) return <Navigate to="/user-applications" replace />;

  let toRender = null;

  const isFetching = isFetching1 || isFetching2;
  const isError = isError1 || isError2;
  const registrationData =
    cookieUtils.getSecureCookie("userRegistrationDetails");
  const userDetails = cookieUtils.getSecureCookie("userDetails");

  const fallbackSubmitterType =
    registrationData?.user_type ?? "";

  const fallbackSubmitterBy =
    userDetails?.name ?? "";

  console.log("edit app", application?.typeOfApplicationSubmitter, 
    fallbackSubmitterType, application?.submitted_by, fallbackSubmitterBy,)

  if (isFetching || isError || !data?.data || !application?.applicationId!) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {isError ||
          (!isFetching && (!data?.data || !application?.applicationId)) ? (
          <p>Something went wrong while fetching info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  } else if (data?.data) {
    toRender = (
      <ApplicationFormContextProvider defaultValue={application}>
        <ApplicationForm
          defaultValues={{
            ...application,
            type_of_application_submitter:
              application?.type_of_application_submitter ??
              fallbackSubmitterType,
            submitted_by:
              fallbackSubmitterBy ?? application?.submitted_by,
          }}
          defaultSteps={[data?.data]}
        />
      </ApplicationFormContextProvider>
    );
  }

  return toRender;
});
